import { api } from "@/api/client";
import type {
  CartridgeAssignmentResponse,
  CartridgeOrgInstallResponse,
  ProjectCartridgeInfo,
} from "@/types/cartridge";

export async function installCartridge(
  name: string,
): Promise<CartridgeOrgInstallResponse> {
  return api<CartridgeOrgInstallResponse>(
    `/api/v2/cartridges/${encodeURIComponent(name)}/install`,
    { method: "POST" },
  );
}

export async function uninstallCartridge(name: string): Promise<void> {
  return api<void>(
    `/api/v2/cartridges/${encodeURIComponent(name)}/install`,
    { method: "DELETE" },
  );
}

export async function assignToProject(
  name: string,
  projectId: string,
  policy: "required" | "optional" = "optional",
): Promise<CartridgeAssignmentResponse> {
  return api<CartridgeAssignmentResponse>(
    `/api/v2/cartridges/${encodeURIComponent(name)}/assignments`,
    {
      method: "POST",
      body: JSON.stringify({ project_id: projectId, policy }),
    },
  );
}

export async function unassignFromProject(
  name: string,
  projectId: string,
): Promise<void> {
  return api<void>(
    `/api/v2/cartridges/${encodeURIComponent(name)}/assignments/${encodeURIComponent(projectId)}`,
    { method: "DELETE" },
  );
}

export async function listProjectCartridges(
  projectId: string,
): Promise<ProjectCartridgeInfo[]> {
  return api<ProjectCartridgeInfo[]>(
    `/api/v2/projects/${encodeURIComponent(projectId)}/cartridges`,
  );
}
